import React from 'react';
import css from './OverlayContainer.css';

function OverlayContainer() {
  return (
    <div id="OverlayContainer" className={css.overlayContainer} />
  );
}

export default OverlayContainer;
